<template>
	<div class="m-4">
		<div class="text-subtitle-2">{{ $t("dashboard.eventSettings") }}</div>
		<div class="grid grid-cols-2 gap-4">
			<SoftSelect
				v-model="vibrationType"
				:label="$t('dashboard.vibrationType')"
				:items="vibrationTypes"
				itemText="name"
				itemValue="value"
			/>
			<SoftSelect v-model="unit" :label="$t('dashboard.unit')" :items="units" />
		</div>
		<div class="grid grid-cols-1 gap-4">
			<SoftSelect v-model="oplUnit" :label="$t('dashboard.units.overpressure')" :items="oplUnits" />
		</div>
	</div>
</template>

<script lang="ts">
import { useDataCatalog } from "@/composable/data-catalog";
import {
	accelerationUnits,
	overpressureUnits,
	velocityUnits,
	VibrationSubType as vst,
} from "@soft-db/data-formatter";
import { useModelValue, useRefObjectSync } from "@soft-db/soft-utils";
import { computed, defineComponent, PropType, watch } from "vue";
import {
	defaultEventWaveformDataOptions,
	EventWaveformDataOptions,
} from "./event-waveform-data-options";

export default defineComponent({
	name: "EventWaveformDataConfig",
	props: {
		modelValue: {
			type: Object as PropType<EventWaveformDataOptions>,
			default: () => ({ ...defaultEventWaveformDataOptions }),
		},
	},
	setup(props) {
		const valueModel = useModelValue(props);

		const vibrationType = useRefObjectSync(valueModel, "vibrationType");
		const unit = useRefObjectSync(valueModel, "unit");
		const oplUnit = useRefObjectSync(valueModel, "oplUnit");
		watch(vibrationType, () => {
			unit.value = "";
		});

		const { generateMenuEntries, VibrationSubType } = useDataCatalog();

		const vibrationTypes = generateMenuEntries(VibrationSubType);
		const oplUnits = computed(() => [...overpressureUnits.filter((element) => element !== "dB")]);

		const units = computed(() =>
			vibrationType.value === vst.ACCELERATION ? [...accelerationUnits] : [...velocityUnits]
		);

		return {
			vibrationType,
			vibrationTypes,
			unit,
			units,
			oplUnit,
			oplUnits,
		};
	},
});
</script>
